<template>
    <div class="tour_swiper">
        <swiper ref="swiper" :options="Options">
            <swiper-slide v-for="(item, index) in group" :key="index" :class="{active: activeIndex == index}">
                <div class="class_name" v-if="isHighSchool && item._index == 0">{{item.className}}</div>
                <div class="cover" :style="`background-image: url(${item.thumbnail});`"></div>
                <div class="text" @click="slideTap(index)">{{item.name}}</div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { mapState } from 'vuex';
export default {
    name: "tourSwiper",
    props: ['activeIndex'],
    data() {
        return {
            isHighSchool: process.env.VUE_APP_IS_HIGH_SCHOOL == '1',
            Options: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                centeredSlides: true,
                centeredSlidesBounds: true,
                navigation: {
                    nextEl: '.tour_swiper .swiper-button-next',
                    prevEl: '.tour_swiper .swiper-button-prev',
                },
                observer: true,
                observeParents: true,
            },
        };
    },
    computed: {
        ...mapState([ 'group', 'classGroup']),
        swiper() {
            return this.$refs.swiper.$swiper
        },
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive
    },
    mounted() {},
    watch: {
        activeIndex: {
            handler: function (val) { 
                this.$nextTick(() => {
                    this.swiper.slideTo(val)
                })
            },
            immediate: true
        },
    },
    methods: {
        slideTap(index){
            this.$emit('slideTap', index);
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.tour_swiper{
    width: 6.5rem;
    padding: 0 .3rem;
    overflow: hidden;
    position: relative;
    .swiper-container{
        width: 100%;
        padding: .25rem 0;
    }
    .swiper-slide{
        width: 1.5rem;
        height: 1rem;
        margin-right: .12rem;
        cursor: pointer;
        color: #fff;
        font-size: .14rem;
        &:last-child{
            margin-right: 0;
        }
        .class_name{
            position: absolute;
            bottom: 100%;
            left: 0;
        }
        .cover{
            border-radius: .04rem;
            height: 100%;
            background-repeat: no-repeat;
            background-size: cover;
        }
        .text{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba($color: #000000, $alpha: 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: .04rem;
            border: .04rem solid #fff;
            text-align: center;
            text-decoration: underline;
            padding: 0 .1rem;
            opacity: 0;
            transition: opacity .3s;
        }
        &.active,
        &:hover{
            .text{
                opacity: 1;
            }
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .3rem;
        height: .3rem;
        top: 50%;
        margin-top: -.15rem;
        background: no-repeat center/.15rem;
        &::after{
            display: none;
        }
    }
    .swiper-button-prev{
        left: 0;
        background-image: url('../assets/images/icon_checked_item_arrow_prev.png');
    }
    .swiper-button-next{
        right: 0;
        background-image: url('../assets/images/icon_checked_item_arrow_next.png');
    }
    @media only screen and (max-width: 640px) {
        width: 100%;
        padding: 0;
        .swiper-container{
            padding: .3rem .3rem;
        }
        .swiper-slide{
            width: 2.56rem;
            height: 1.6rem;
            margin-right: .2rem;
        }
        .swiper-button-prev,
        .swiper-button-next{
            display: none;
        }
    }
}
</style>